import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Container as RContainer } from 'rebass';

import { Box, Image as BaseImage, ResponsiveBox } from 'src/Components/Base';

import SideMenu from './SideMenu';

const Wrapper = styled(Box)`
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  ${props =>
    props.variant === 'campaign' &&
    css`
      /* background: top center no-repeat; */
      background-image: url('images/confirm/tidlaew_ornaments_header.png'),
        linear-gradient(to bottom, #fff 35%, #f49ca1);
      background-position: top center;
      background-repeat: no-repeat;
    `}
`;

const Container = styled(RContainer)`
  display: flex;
  position: relative;
  flex-direction: row;
  min-height: 100%;
  width: 100%;
`;

const Image = styled(BaseImage)`
  height: auto;

  @media print {
    display: none;
  }
`;

Image.defaultProps = {
  ...Image.defaultProps,
  mt: 'auto',
  mx: 'auto',
};

const FooterImage = styled(Image)`
  min-height: 240px;
  object-fit: cover;
  object-position: left;
`;

const ConfirmFooterImage = styled(Image)`
  width: 100%;
  @media screen and (min-width: 1200px) {
    margin-top: -120px;
    width: 1200px;
  }
`;

const AppContainer = ({ menus, containerStyle, maxWidth = 1280, variant, children }) => {
  const filteredMenus = menus.filter(menu => menu.hideMenu !== true);
  const isCampaignLayout = variant === 'campaign';

  const renderFooter = () =>
    isCampaignLayout ? (
      <ConfirmFooterImage src="images/confirm/tidlaew_ornaments_footer.png" />
    ) : (
      <FooterImage
        srcSet={
          '/images/footer/footer.jpg 1366w, /images/footer/footer@2x.jpg 2732w, /images/footer/footer@3x.jpg 4098w'
        }
        src={'/images/footer/footer.jpg'}
        align={'left'}
      />
    );

  return (
    <Wrapper style={containerStyle} variant={variant}>
      <Container
        py={isCampaignLayout ? [2, null, 4] : 4}
        px={[2, 3, 4]}
        maxWidth={isCampaignLayout ? maxWidth : ['100%', null, null, null, maxWidth]}
      >
        {filteredMenus.length > 0 && (
          <ResponsiveBox
            mr={[0, null, null, 48]}
            display={isCampaignLayout ? ['block', null, null, 'none'] : 'block'}
          >
            <SideMenu items={filteredMenus} />
          </ResponsiveBox>
        )}
        <Box width={1} style={{ minWidth: 0 }}>
          {children}
        </Box>
      </Container>
      {renderFooter()}
    </Wrapper>
  );
};

AppContainer.propTypes = {
  menus: PropTypes.array,
  containerStyle: PropTypes.object,
  variant: PropTypes.string,
};

AppContainer.defaultProps = {
  menus: [],
};

export default AppContainer;
